
export default class Request {
  constructor(token) {
    this.token = token;
  }

  status(response) {
    if (response.status >= 200 && response.status < 300) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(new Error(response.statusText))
    }
  }

  handleResponse(handleAs, response) {
    switch (handleAs) {
      case 'text':
        return response.text();
      default:
        return response.json();
    }
  }

  addArrayToFormData(propName, propArray, formData) {
    propArray.forEach(value => {
      formData.append(propName, value);
    });
  }

  objectToFormData(obj) {
    const body = new FormData();
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        if (Array.isArray(obj[prop])) {
          this.addArrayToFormData(prop, obj[prop], body);
        } else {
          body.append(prop, obj[prop]);
        }
      }
    }

    // Add 'f=json' (we used to only add if it didn't already exist, but IE)
    body.append('f', 'json');

    return body;
  }

  objectToUrlSearchParams(obj) {
    const body = new URLSearchParams();
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        body.append(prop, obj[prop]);
      }
    }

    // add f=json if not included
    if (!body.has('f')) {
      body.append('f', 'json');
    }

    return body.toString();
  }

  getHeaders(isFormData) {
    const headers = {};

    if (!isFormData)
    {
      headers['content-type'] = 'application/x-www-form-urlencoded';
    }

    return new Headers(headers);
  }

  getFileHeaders()
  {
    const headers = {};
    headers['content-type'] = 'multipart/form-data';
    return new Headers(headers);
  }

  upload(requestUrl, data) {
  let options = {
    method: 'POST'
  };

  options.body = new FormData();
  options.body.append('file', data);

  return fetch(requestUrl, options)
      .then(response => {
        return response.json()
          .then(responseJson => {
            return responseJson;
          });
      });
}

uploadFile(requestUrl, data, indices, uploadUsername, selectedCategory) {
  let options = {
    method: 'POST'
  };

  options.body = new FormData();
  options.body.append('file', data);
  options.body.append('indicesOutsideState', JSON.stringify(indices));
  options.body.append('uploadUsername', uploadUsername);
  options.body.append('selectedCategory', selectedCategory);

  return fetch(requestUrl, options)
      .then(response => {
        return response.json()
          .then(responseJson => {
            return responseJson;
          });
      });
}

  getRequestBody(data, isFormData) {
    // if formdata, make formdata
    if (isFormData) {
      return this.objectToFormData(data);
    }

    // Not formdata, make url param
    return this.objectToUrlSearchParams(data);
  }

  makeCsvRequest(params) {
    return new Promise((resolve, reject) => {
      let url = params.url;
      const data = params.data || {};
      const headers = this.getHeaders(params.isFormData);
      const options =
      {
        method: params.method || 'get',
        headers
      };

      if (!params.hideCredentials)
      {
        options.credentials = 'include';
      }

      let body = this.getRequestBody(data, params.isFormData);

      if (options.method === 'get') {
        url = `${url}?${body}`;
      } else {
        options.body = body;
      }

      fetch(url, options)
      .then((resp) => {
        resolve(resp.text());
        //const reader = resp.body().getReader();
        //response.text()

        /*  let json = resp.json(); // there's always a body
          if (resp.status >= 200 && resp.status < 300) {
            return json;
          } else {
            return json.then(Promise.reject.bind(Promise));
          } */
      }).catch(function(error)
      {
        reject(error);
      });
    });
  }

  /**
   * Make a request using fetch()
   * @param  { Object } params Object containing key/value parameters to pass to fetch()
   * @return { Promise}        Promise returned by fetch()
   */
  makeRequest(params) {
    return new Promise((resolve, reject) => {
      let url = params.url;
      const data = params.data || {};
      const headers = this.getHeaders(params.isFormData);
      const options = {
        method: params.method || 'get',
        headers
      };

      if (!params.hideCredentials) {
        options.credentials = 'include';
      }

      let body = this.getRequestBody(data, params.isFormData);

      if (options.method === 'get') {
        url = `${url}?${body}`;
      } else {
        options.body = body;
      }

      fetch(url, options)
      .then(this.status)
      .then(this.handleResponse.bind(null, params.handleAs))
      .then(function(data)
      {
        // Handle successful requests that are actually errors...
        if (data.error) {
          reject(data.error);
          return;
        }
        resolve(data);
      }).catch(function(error)
      {
        reject(error);
      });
    });
  }

  makeFileRequest(params) {
    return new Promise((resolve, reject) => {
      let url = params.url;
      const data = params.data || {};
      const headers = this.getFileHeaders();
      const options = {
        method: params.method || 'get',
        headers
      };

      if (!params.hideCredentials) {
        options.credentials = 'include';
      }

      let body = this.getRequestBody(data, params.isFormData);

      if (options.method === 'get') {
        url = `${url}?${body}`;
      } else {
        options.body = body;
      }

      fetch(url, options)
      .then(this.status)
      .then(this.handleResponse.bind(null, params.handleAs))
      .then(function(data) {
        // Handle successful requests that are actually errors...
        if (data.error) {
          reject(data.error);
          return;
        }
        resolve(data);
      }).catch(function(error) {
        reject(error);
      });
    });
  }
}
